<template>
  <div :style="{ width, display: 'flex' }" :class="$style['reviewset-select']">
    <ValidationProvider v-slot="{ errors }" :rules="rules" :name="label" :vid="name">
      <CSelect
              :invalidFeedback="errors[0]"
              :name="name"
              :value.sync="localValue"
              :isValid="errors[0] ? false : null"
              :options="options"
              :class="$style['question']"
              placeholder="---"
      ></CSelect>
    </ValidationProvider>
    <span :class="$style['answer']">{{ answer }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    options: {
      type: Array,
      required: true
    },
    textKey: {
      type: String,
      default: "text"
    },
    valueKey: {
      type: String,
      default: "value"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    rules: {
      type: String
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    limit: {
      type: Number,
      default: null
    },
    width: {
      type: String,
      default: "200px"
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    answerItems() {
     return this.$store.getters['templates/entity/answerItems'];
    },
    answer() {
      if (!this.localValue) {
        return '';
      }
      return this.answerItems[this.localValue] ? this.answerItems[this.localValue] : '自由回答';
    }
  },
  methods: {
    checkLimit(selections) {
      if (this.multiple && this.limit > 1 && selections.length > this.limit) {
        selections.splice(this.limit);
      }
    }
  }
};
</script>

<style module lang="scss">
.select-field {
  font-size: 13px;
}
.question {
  width: 330px;
}
.answer {
  margin-top: 4px;
}
.reviewset-select {
  span {
    &:first-child {
      width: 420px;
    }
  }
}
</style>
